import ImageNodeView from './nodes/ImageNodeView';
import MathInlineNodeView from './nodes/MathInlineNodeView';
import MathBlockNodeView from './nodes/MathBlockNodeView';
import CodeBlockNodeView from './nodes/CodeBlockNodeView';
import ContainerMessageNodeView from './nodes/ContainerMessageNodeView';
import ContainerMermaidNodeView from './nodes/ContainerMermaidNodeView';
import ContainerPlantumlNodeView from './nodes/ContainerPlantumlNodeView';
import CheckBoxItemNodeView from './nodes/CheckBoxItemNodeView';
import FormNodeView from '../PageEditor/nodes/FormNodeView';
import FormFieldNodeView from '../PageEditor/nodes/FormFieldNodeView';
import FormSelectNodeView from '../PageEditor/nodes/FormSelectNodeView';

import LinkMarkView from './marks/LinkMarkView';
import TableOfContentsNodeView from './nodes/TableOfContentsNodeView';
import GridColumnNodeView from './nodes/GridColumnNodeView';
import AccordionTitleNodeView from './nodes/AccordionTitleNodeView';
import RelativeTimeMarkView from "./marks/RelativeTimeMarkView";

export const nodeViews = {
    image: (node, view, getPos) => {
        return new ImageNodeView(node, view, getPos);
    },
    math_inline: (node, view, getPos) => {
        return new MathInlineNodeView(node, view, getPos);
    },
    math_block: (node, view, getPos) => {
        return new MathBlockNodeView(node, view, getPos);
    },
    code_block: (node, view, getPos) => {
        return new CodeBlockNodeView(node, view, getPos);
    },
    container_message: (node, view, getPos) => {
        return new ContainerMessageNodeView(node, view, getPos);
    },
    code_container_mermaid: (node, view, getPos) => {
        return new ContainerMermaidNodeView(node, view, getPos);
    },
    code_container_plantuml: (node, view, getPos) => {
        return new ContainerPlantumlNodeView(node, view, getPos);
    },
    checkbox_item: (node, view, getPos) => {
        return new CheckBoxItemNodeView(node, view, getPos);
    },
    form: (node, view, getPos) => {
        return new FormNodeView(node, view, getPos);
    },
    form_field: (node, view, getPos) => {
        return new FormFieldNodeView(node, view, getPos);
    },
    form_select: (node, view, getPos) => {
        return new FormSelectNodeView(node, view, getPos);
    },
    table_of_contents: (node, view, getPos) => {
        return new TableOfContentsNodeView(node, view, getPos);
    },
    grid_column: (node, view, getPos) => {
        return new GridColumnNodeView(node, view, getPos);
    },
    accordion_title: (node, view, getPos) => {
        return new AccordionTitleNodeView(node, view, getPos);
    }
}

export const markViews = {
    link: (mark, view, inline) => {
        return new LinkMarkView(mark, view, inline);
    },
    relative_time: (mark, view, inline) => {
        return new RelativeTimeMarkView(mark, view, inline);
    }
}